/**
 * Consenso modulare (KB-SCHEMA ConsentGrant): uno scope per card, cosa succede e con chi,
 * stato scritto in parole ("Attivo" / "Non attivo"), revocabile quando vuole.
 */
import type { ConsentScope } from '../types'
import { PrimaryButton } from './PrimaryButton'
import { SecondaryButton } from './SecondaryButton'

export type ConsentCardProps = {
  scope: ConsentScope
  title: string
  /** Cosa viene usato e per cosa, in una o due frasi. */
  description: string
  granted: boolean
  onGrant?: (scope: ConsentScope) => void
  onRevoke?: (scope: ConsentScope) => void
}

export function ConsentCard({ scope, title, description, granted, onGrant, onRevoke }: ConsentCardProps) {
  const titleId = `consenso-${scope}`
  return (
    <section aria-labelledby={titleId} className="rounded-card border-2 border-line bg-surface px-[22px] py-[20px]">
      <h2 id={titleId} className="text-band font-bold text-ink">
        {title}
      </h2>
      <p className="mt-1 text-meta text-ink">
        Stato: <strong>{granted ? 'Attivo' : 'Non attivo'}</strong>
      </p>
      <p className="mt-3 text-body text-ink">{description}</p>
      <p className="text-soft mt-2 text-meta text-ink">Può cambiare idea quando vuole, da Impostazioni.</p>
      {granted ? (
        <div className="mt-4">
          <SecondaryButton onClick={() => onRevoke?.(scope)}>Ritiro il consenso</SecondaryButton>
        </div>
      ) : (
        <PrimaryButton onClick={() => onGrant?.(scope)}>Acconsento</PrimaryButton>
      )}
    </section>
  )
}
